define([
    "jquery",
    "underscore",
    "marionette",
    "templates/common/chart.html",
    "echarts/lib/echarts",
    "echarts/lib/chart/bar",
    "echarts/lib/component/legend",
    "echarts/lib/chart/pie",
    "echarts/lib/chart/line",
    "echarts/lib/component/tooltip"
], function($, _, Marionette, chartTpl, echarts) {
    return Marionette.ItemView.extend({
        template: chartTpl,
        ui:{
            'chartContainer': '.chart_container',
            'leftControls': '.left.carousel-control',
            'rightControls': '.right.carousel-control',
            'noData': '.no_data'
        },

        templateHelpers: function () {
            return {
                navigation: this.navigation
            };
        },

        events:{
            'click @ui.leftControls': function(e){
                e.preventDefault();

                if("left" === this.nextPagePosition){
                    this._nextPage();
                }else{
                    this._prevPage();
                }
            },
            'click @ui.rightControls': function(e){
                e.preventDefault();

                if("right" === this.nextPagePosition){
                    this._nextPage();
                }else{
                    this._prevPage();
                }
            }
        },

        initialize: function(config){
            this.config = _.extend({}, {
                color: window.chartColors
            }, config);
            this.nextPagePosition = _.has(config.pagination, 'nextPagePosition') ? config.pagination.nextPagePosition : 'right';
            this.length = _.has(config.pagination, 'length') ? config.pagination.length : 10;
            this.navigation = _.has(config.pagination, 'navigation') ? config.pagination.navigation : true;
            this.currentPage = 1;
        },

        onAttach: function(){
            this.echart = echarts.init(this.ui.chartContainer[0]);
            this.echart.setOption(this.config);

            this._doAjax();
        },

        reload: function(){
            this.currentPage = 1;

            this._doAjax();
        },

        _nextPage: function(){
            if(this.totalPages >= this.currentPage+1){
                this.currentPage++;
                this._doAjax();
            }
        },

        _prevPage: function(){
            if(0 < (this.currentPage-1)){
                this.currentPage--;
                this._doAjax();
            }
        },

        _doAjax: function(){
            var that = this;

            this.ui.noData.hide();
            this.ui.chartContainer.show(); 
            this.echart.showLoading();

            var data = {
                start: Math.max(this.length*(this.currentPage-1), 0),
                length: this.length
            };

            // If the config contains a prepareData function, we'll run it.
            if(this.config.ajax.prepareData){
                data = _.extend(data, this.config.ajax.prepareData());
            }

            // ALL the ajax options can be overiden. However I don't recommend overidding success().
            $.ajax(_.extend({
                data: data,
                success: function(data){
                    var parsedData = that.config.ajax.parseData(data) || data;

                    that.echart.setOption(parsedData);
                    that.recordsTotal = parseInt(data.recordsTotal);
                    that.recordsFiltered = parseInt(data.recordsFiltered);
                    that.totalPages = Math.ceil(that.recordsFiltered / that.length);
                    that.echart.hideLoading();

                    if(0 >= that.recordsTotal){
                        that.ui.noData.show();
                        that.ui.chartContainer.hide();
                    }
                }
            }, this.config.ajax));
        }
    });
});
